// extracted by mini-css-extract-plugin
export var container = "_5f-1";
export var editor = "_5f-2";
export var resizable = "_5f-3";
export var wrapper = "_5f-0";